import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAxios from "../../../Utils/useAxios";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import FormCapaianSS from "./FormCapaianSS";
import { FORM_TYPE } from "../../../Constant/FormType";

const EditCapaianSS = () => {
  const axiosInstance = useAxios();
  const { capaianSSId } = useParams();
  const [formCapaianSS, setFormCapaianSS] = useState({
    entitas: "",
    perspektif: "",
    kode_ss: "",
    nama_ss: "",
    bobot_sasaran_strategis: "",
    capaian_tw_1: "",
    capaian_tw_2: "",
    capaian_tw_3: "",
    capaian_tw_4: "",
    capaian_normalisasi_tw_1: "",
    capaian_normalisasi_tw_2: "",
    capaian_normalisasi_tw_3: "",
    capaian_normalisasi_tw_4: "",
    nilai_sasaran_strategis_tw_1: "",
    nilai_sasaran_strategis_tw_2: "",
    nilai_sasaran_strategis_tw_3: "",
    nilai_sasaran_strategis_tw_4: "",
    nilai_sasaran_strategis_normalisasi_tw_1: "",
    nilai_sasaran_strategis_normalisasi_tw_2: "",
    nilai_sasaran_strategis_normalisasi_tw_3: "",
    nilai_sasaran_strategis_normalisasi_tw_4: "",
    anggaran: "",
    komitmen: "",
    aktual: "",
    sisa_anggaran: ""
  });

  let isMounted = true
  useEffect(() => {
    getCapaianSS();

    return() => {
      isMounted = false
    }
  }, [])

  const getCapaianSS = async () => {
    try {
      const response = await axiosInstance.get(`capaian-ss/${capaianSSId}`)
      if (isMounted) {
        setFormCapaianSS(response.data)
      }
    } catch (e) {
      console.error(e);
      toast.error(e.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    }
  }

  return (
    <FormCapaianSS
      formCapaianSS={formCapaianSS}
      setFormCapaianSS={setFormCapaianSS}
      formType={FORM_TYPE.Edit}
    />
  )
}


export default EditCapaianSS;